import React from 'react';

export default ({goToLink, name}) => {
    return (
        <span
          onClick={() => goToLink(name)}
          className="doc-link">{name}</span>
    );
};
